module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/CardsPoster-09d540c33e1b47e5c5b91bd0141a6ae8.jpg";